import { castToOption } from 'src/helpers';

export enum UsaState {
  Alabama = 'AL',
  Alaska = 'AK',
  Arizona = 'AZ',
  Arkansas = 'AR',
  California = 'CA',
  Colorado = 'CO',
  Connecticut = 'CT',
  Delaware = 'DE',
  DistrictOfColumbia = 'DC',
  Florida = 'FL',
  Georgia = 'GA',
  Hawaii = 'HI',
  Idaho = 'ID',
  Illinois = 'IL',
  Indiana = 'IN',
  Iowa = 'IA',
  Kansas = 'KS',
  Kentucky = 'KY',
  Louisiana = 'LA',
  Maine = 'ME',
  Maryland = 'MD',
  Massachusetts = 'MA',
  Michigan = 'MI',
  Minnesota = 'MN',
  Mississippi = 'MS',
  Missouri = 'MO',
  Montana = 'MT',
  Nebraska = 'NE',
  Nevada = 'NV',
  NewHampshire = 'NH',
  NewJersey = 'NJ',
  NewMexico = 'NM',
  NewYork = 'NY',
  NorthCarolina = 'NC',
  NorthDakota = 'ND',
  Ohio = 'OH',
  Oklahoma = 'OK',
  Oregon = 'OR',
  Pennsylvania = 'PA',
  RhodeIsland = 'RI',
  SouthCarolina = 'SC',
  SouthDakota = 'SD',
  Tennessee = 'TN',
  Texas = 'TX',
  Utah = 'UT',
  Vermont = 'VT',
  Virginia = 'VA',
  Washington = 'WA',
  WestVirginia = 'WV',
  Wisconsin = 'WI',
  Wyoming = 'WY',
}

export const USA_STATE_NAME: Record<UsaState, string> = {
  [UsaState.Alabama]: 'Alabama',
  [UsaState.Alaska]: 'Alaska',
  [UsaState.Arizona]: 'Arizona',
  [UsaState.Arkansas]: 'Arkansas',
  [UsaState.California]: 'California',
  [UsaState.Colorado]: 'Colorado',
  [UsaState.Connecticut]: 'Connecticut',
  [UsaState.Delaware]: 'Delaware',
  [UsaState.DistrictOfColumbia]: 'District of Columbia',
  [UsaState.Florida]: 'Florida',
  [UsaState.Georgia]: 'Georgia',
  [UsaState.Hawaii]: 'Hawaii',
  [UsaState.Idaho]: 'Idaho',
  [UsaState.Illinois]: 'Illinois',
  [UsaState.Indiana]: 'Indiana',
  [UsaState.Iowa]: 'Iowa',
  [UsaState.Kansas]: 'Kansas',
  [UsaState.Kentucky]: 'Kentucky',
  [UsaState.Louisiana]: 'Louisiana',
  [UsaState.Maine]: 'Maine',
  [UsaState.Maryland]: 'Maryland',
  [UsaState.Massachusetts]: 'Massachusetts',
  [UsaState.Michigan]: 'Michigan',
  [UsaState.Minnesota]: 'Minnesota',
  [UsaState.Mississippi]: 'Mississippi',
  [UsaState.Missouri]: 'Missouri',
  [UsaState.Montana]: 'Montana',
  [UsaState.Nebraska]: 'Nebraska',
  [UsaState.Nevada]: 'Nevada',
  [UsaState.NewHampshire]: 'New Hampshire',
  [UsaState.NewJersey]: 'New Jersey',
  [UsaState.NewMexico]: 'New Mexico',
  [UsaState.NewYork]: 'New York',
  [UsaState.NorthCarolina]: 'North Carolina',
  [UsaState.NorthDakota]: 'North Dakota',
  [UsaState.Ohio]: 'Ohio',
  [UsaState.Oklahoma]: 'Oklahoma',
  [UsaState.Oregon]: 'Oregon',
  [UsaState.Pennsylvania]: 'Pennsylvania',
  [UsaState.RhodeIsland]: 'Rhode Island',
  [UsaState.SouthCarolina]: 'South Carolina',
  [UsaState.SouthDakota]: 'South Dakota',
  [UsaState.Tennessee]: 'Tennessee',
  [UsaState.Texas]: 'Texas',
  [UsaState.Utah]: 'Utah',
  [UsaState.Vermont]: 'Vermont',
  [UsaState.Virginia]: 'Virginia',
  [UsaState.Washington]: 'Washington',
  [UsaState.WestVirginia]: 'West Virginia',
  [UsaState.Wisconsin]: 'Wisconsin',
  [UsaState.Wyoming]: 'Wyoming',
};

export const USA_STATE_OPTIONS = castToOption(UsaState, USA_STATE_NAME);
